<template>
    <div class="mobile-wallets-checkout py-1">
        <div v-if="loading" class="text-center mx-auto mt-4 mb-8">
            <v-progress-circular indeterminate transition="fade-transition" color="teal darken-3" size="30" width="2"></v-progress-circular>
        </div>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        amount: {
            required: true,
        },
        staging: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return {
            loading: false,
        }
    },
    computed: {
        ...GlobalComputed,
        
    },
    methods: {
        ...GlobalMethods,
        initOrder(){
            if (!this.loading){
                this.loading = true;
                  
                this.$store.dispatch('createShakeoutOrder', {amount: this.amount}).then(response=>{
                    const url = response.data.url;
                    window.open(url, '_system');
                    this.$emit('done');
                    
                    this.loading = false;

                }).catch(e=>{
                    console.error(e)
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تنفيذ الإجراء، حاول مرة أخرى', 'error');
                })
            }
        },
    },
    mounted(){
       this.initOrder();
    }
}
</script>

<style lang="scss">
</style>